export default __webpack_public_path__ + "static/media/teksan-logo-dark.8c06ca8a.png";